<div class="container">
  <ng-container *ngIf="data.resultTypeValue == 1 && stoolDetails">
    <table mat-table [dataSource]="stoolDetails" [style.width.%]="100">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Lab Result</th>
        <td mat-cell *matCellDef="let element">Stool Result</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="classification">
        <th mat-header-cell *matHeaderCellDef>Classification</th>
        <td mat-cell *matCellDef="let element">
          {{ element.stoolClassification.name }}
        </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="color">
        <th mat-header-cell *matHeaderCellDef>Color</th>
        <td mat-cell *matCellDef="let element">
          {{ element.stoolColor.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="consistency">
        <th mat-header-cell *matHeaderCellDef>Consistency</th>
        <td mat-cell *matCellDef="let element">
          {{ element.stoolConsistency.name }}
        </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="microscopy">
        <th mat-header-cell *matHeaderCellDef>Microscopic Examination</th>
        <td mat-cell *matCellDef="let element">
          {{ element.microscopicExamination.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="remarks">
        <th mat-header-cell *matHeaderCellDef>Remarks</th>
        <td mat-cell *matCellDef="let element">
          {{ element.remarks.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="method">
        <th mat-header-cell *matHeaderCellDef>Method</th>
        <td mat-cell *matCellDef="let element">
          {{ element.stoolMethod.name }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="stoolColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: stoolColumns"></tr>
    </table>
  </ng-container>
  <ng-container *ngIf="data.resultTypeValue == 2 && xrayDetails">
    <table mat-table [dataSource]="xrayDetails" [style.width.%]="100">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Lab Result</th>
        <td mat-cell *matCellDef="let element">Xray Result</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="impressions">
        <th mat-header-cell *matHeaderCellDef>Impressions</th>
        <td mat-cell *matCellDef="let element">
          {{ element.impressions }}
        </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="remarks">
        <th mat-header-cell *matHeaderCellDef>Remarks</th>
        <td mat-cell *matCellDef="let element">
          {{ element.remarks[0]?.comment }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="xrayColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: xrayColumns"></tr>
    </table>
  </ng-container>
  <ng-container *ngIf="data.resultTypeValue == 3 && rprDetails">
    <table mat-table [dataSource]="rprDetails" [style.width.%]="100">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Lab Result</th>
        <td mat-cell *matCellDef="let element">Syphilis Screening Test Result</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="findings">
        <th mat-header-cell *matHeaderCellDef>Findings</th>
        <td mat-cell *matCellDef="let element">
          {{ element.findings }}
        </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="remarks">
        <th mat-header-cell *matHeaderCellDef>Remarks</th>
        <td mat-cell *matCellDef="let element">
          {{ element.remarks[0].comment }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="rprColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: rprColumns"></tr>
    </table>
  </ng-container>

  <div class="mt-5 d-flex flex-row-reverse">
    <div></div>
    <button mat-raised-button color="secondary" (click)="dialogRef.close()">
      Close
    </button>
  </div>
</div>
